import styled from 'styled-components';

import { BackgroundElement } from '@/core/interfaces/common';

import { colors } from '@/utils/constants';
import mediaQueries from '@/utils/mediaQueries';

const { xxxsmall } = mediaQueries;

export const TypeButtonsWrapper = styled.div<BackgroundElement>`
  display: inline-flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: 40px auto 12px;
  border: 1px solid ${({ backgroundcolor }) => backgroundcolor};
  border-radius: 8px;
  padding: 4px;
  background-color: ${colors.white};

  @media ${xxxsmall} {
    width: 100%;
  }
`;

interface RadioLabel extends BackgroundElement {
  checked: boolean;
}

export const TypeRadio = styled.label<RadioLabel>`
  display: inline-block;
  border-radius: 4px;
  padding: 13px 16px;
  background-color: ${props => (props.checked ? props.backgroundcolor : colors.white)};
  color: ${props => (props.checked ? props.textcolor : colors.black)};
  font-size: 16px;
  cursor: pointer;

  input {
    position: fixed;
    opacity: 0;
    width: 0;
  }

  &:focus-within {
    outline: 2px solid #000;
    outline-offset: 2px;
  }

  @media ${xxxsmall} {
    flex: 1 1 auto;
    padding: 10px 12px;
    text-align: center;
    font-size: 14px;
  }
`;
